module.exports = __webpack_public_path__ + "img/digital_face.756e905f.png";